<template>
  <div style="background: #fff;padding: 13px 20px;">
    <div class="filter-container">
      <el-input v-model="listQuery.proModule" style="width: 200px;" class="filter-item" placeholder="module" @keyup.enter.native="searchTable" />
      <el-input v-model="listQuery.factory" style="width: 200px;" class="filter-item" placeholder="factory" @keyup.enter.native="searchTable" />
      <el-input v-model="listQuery.specs" style="width: 200px;" class="filter-item" placeholder="specs" @keyup.enter.native="searchTable" />
      <el-input v-model="listQuery.address" style="width: 200px;" class="filter-item" placeholder="address" @keyup.enter.native="searchTable" />
      <el-button class="filter-item" :title="$t('titles.search')" type="primary" icon="el-icon-search" @click="searchTable" />
      <el-button class="filter-item" :title="$t('titles.addModel')" type="primary" icon="el-icon-plus" style="margin-left: 0;" @click="add" />
    </div>

    <el-table v-loading.body="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>

      <el-table-column :label="$t('adminView.Model')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.proModule }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="工厂" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.factory }}</span>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('adminView.Dimension')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.specs }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('basicinfo.Voltage')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.voltage }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('AllDevices.Current')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.current }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('adminView.Manual')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.pdfFile }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('yhubReport.Operating')" width="150" align="center">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click.native.prevent="edit(scope.row)"> 编辑 </el-button> -->
          <el-button type="primary" icon="el-icon-edit" :title="$t('titles.edit')" size="mini" style="vertical-align: top;margin-left: 10px;" @click="edit(scope.row)" />
          <el-button type="primary" icon="el-icon-delete" :title="$t('titles.delete')" size="mini" style="vertical-align: top;margin-left: 10px;" @click="deleteRow(scope.row)" />
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        v-if="pageshow"
        background
        current-page.sync="listQuery.pageInfo.page"
        :page-sizes="listQuery.pageInfo.pageList"
        :page-size="listQuery.pageInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listQuery.pageInfo.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="editFormDialog">
      <p v-if="isAdd" style="line-height: 24px;font-size: 18px;color: #303133;margin:-40px 0 15px 0;">{{ $t('adminView.add') }}</p>
      <p v-else style="line-height: 24px;font-size: 18px;color: #303133;margin:-40px 0 15px 0;">{{ $t('adminView.Edit') }}</p>
      <el-form ref="dataForm" :inline="true" :model="dataModel" label-width="120px" class="demo-form-inline">
        <el-form-item :label="$t('adminView.Model')">
          <el-input v-model="dataModel.proModule" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('adminView.Dimension')">
          <el-input v-model="dataModel.specs" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('basicinfo.Voltage')">
          <el-input v-model="dataModel.voltage" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('AllDevices.Current')">
          <el-input v-model="dataModel.current" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('adminView.Manual')">
          <el-input v-model="dataModel.pdfFile" @input="change($event)" />
          <!-- <el-button class="filter-item" type="primary" icon="el-icon-upload2" style="margin-top: -2px;margin-bottom: 0;" @click="uploadVersion" /> -->
        </el-form-item>
        <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col remarkCol">
          <el-form-item :label="$t('adminView.JSONData')">
            <el-input v-model="dataModel.extData" :autosize="{ minRows: 3, maxRows: 10}" type="textarea" @input="change($event)" />
            <p>For Example:</p>
            <p>
              {"title": "750W  24V 30A\nGPSC 3024 \nBATTERY CHARGER",
              "str": "Efficient | Durable | Smart",
              "list":[{"zh":"输出功率","en":"Output Power","value":"750W"}]
              }
            </p>
          </el-form-item>
        </el-col>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editFormDialog = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="submitForm">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getList, update, add, moduleDelete } from '@/api/QR'
import { pagination } from '@/utils/init_table'
import i18n from '@/i18n'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      listLoading: true,
      pageshow: true,
      listQuery: {
        proModule: null,
        factory: null,
        specs: null,
        address: null,
        pageInfo: pagination()
      },
      editFormDialog: false,
      dataModel: {
        id: null
      },
      isAdd: true
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    queryList() {
      this.listLoading = true
      var param = {
        address: this.listQuery.address,
        factory: this.listQuery.factory,
        proModule: this.listQuery.proModule,
        specs: this.listQuery.specs,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      getList(param).then(response => {
        this.list = response.resultModel.list
        this.listQuery.pageInfo.total = response.resultModel.total
        this.listLoading = false
      })
    },
    searchTable() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    handleSizeChange(val, e) {
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    add() {
      this.dataModel = {}
      this.editFormDialog = true
      this.isAdd = true
    },
    edit(row) {
      for (var key in row) {
        this.dataModel[key] = row[key]
      }
      this.editFormDialog = true
      this.isAdd = false
    },
    deleteRow(row) {
      this.$confirm(i18n.t('adminView.ConfirmDelete'), '', {// '是否确定删除？'
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        moduleDelete({ 'id': row.id }).then(res => {
          if (res.resultCode == '1001') {
            this.$message({
              type: 'success',
              message: i18n.t('lease.Succeed') // 解锁成功
            })
          }
          this.queryList()
        })
      }).catch(() => {})
    },
    submitForm() {
      if (this.isAdd) { // 新增
        add(this.dataModel).then(response => {
          if (response.resultCode == 1001) {
            this.queryList()
            this.editFormDialog = false
            this.$notify({
              title: '',
              message: i18n.t('lease.Succeed'),
              type: 'success',
              duration: 2000
            })
          } else {
            this.$notify({
              title: '',
              message: i18n.t('lease.Failed'), // '提交失败',
              type: 'error',
              duration: 2000
            })
          }
        })
      } else {
        update(this.dataModel).then(response => {
          if (response.resultCode == 1001) {
            this.queryList()
            this.editFormDialog = false
            this.$notify({
              title: '',
              message: i18n.t('lease.Succeed'),
              type: 'success',
              duration: 2000
            })
          } else {
            this.$notify({
              title: '',
              message: i18n.t('lease.Failed'), // '提交失败',
              type: 'error',
              duration: 2000
            })
          }
        })
      }
    },
    change(e) {
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss">
.remarkCol{
  .el-form-item{
    width: 80%;
  }
  .el-form-item__content{
    width: calc(100% - 120px);
    min-width:185px;
  }
}
</style>
